import { Selector } from '@ngxs/store';
import { SchooladviezenState } from '@store/states/schooladviezen.state';
import { SchooladviezenStateModel } from '@store/models/schooladviezen.model';

export class SchooladviezenSelectors {
  @Selector([SchooladviezenState])
  static schooladviezen(state: SchooladviezenStateModel) {
    const schooladviezen = state.schooladviezen;
    return schooladviezen;
  }

}
